/* ZIRAK SHARE - one delegated handler for every [data-zb-share] button (cards + product page) */
(function () {
  if (window.zbShareInit) return;
  window.zbShareInit = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-zb-share]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var url = btn.getAttribute('data-url');
    var title = btn.getAttribute('data-title');
    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function () {});
      return;
    }
    var done = function () {
      btn.classList.add('is-copied');
      setTimeout(function () { btn.classList.remove('is-copied'); }, 1800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done).catch(function () {});
    } else {
      var t = document.createElement('textarea');
      t.value = url;
      document.body.appendChild(t);
      t.select();
      try { document.execCommand('copy'); done(); } catch (err) {}
      document.body.removeChild(t);
    }
  });
})();

/* ZIRAK CARD PHOTO TAP - the card photo area now sits above Dawn's invisible whole-card link
   (see zirak-card-badges.css), so a tap on a photo that is NOT already a link (single-photo cards,
   before the swipe strip loads) opens the product here. Ctrl/Cmd-click opens a new tab. */
(function () {
  if (window.zcTapInit) return;
  window.zcTapInit = true;
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented) return;
    var inner = e.target.closest && e.target.closest('.product-card-wrapper .card__inner');
    if (!inner) return;
    if (e.target.closest('a, button, input, select, label, [role="button"], quick-add-modal, modal-opener, [data-zw-handle], .zc-actions')) return;
    var wrap = inner.closest('.product-card-wrapper');
    var link = wrap && wrap.querySelector('.card__heading a[href], a[href*="/products/"]');
    if (!link) return;
    if (e.metaKey || e.ctrlKey || e.button === 1) window.open(link.href, '_blank');
    else window.location.href = link.href;
  });
})();

/* ZIRAK CARD SWIPE HELPER - makes the product-card photo strip (built by zp-card-swipe.js) slide
   reliably with a finger on mobile AND with the mouse on desktop. The page still scrolls up/down
   normally; only clearly sideways movements slide the photos. A plain tap/click still opens the product. */
(function () {
  if (window.zcDragInit) return;
  window.zcDragInit = true;

  var AXIS_LOCK = 8;   // px before deciding sideways vs up/down
  var drag = null;

  function start(track, x, y, type) {
    drag = { track: track, startX: x, startY: y, lastX: x, startLeft: track.scrollLeft, axis: null, type: type };
  }
  function move(x, y) {
    if (!drag) return false;
    var dx = x - drag.startX;
    var dy = y - drag.startY;
    drag.lastX = x;
    if (!drag.axis) {
      if (Math.abs(dx) < AXIS_LOCK && Math.abs(dy) < AXIS_LOCK) return false;
      drag.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      if (drag.axis === 'x') {
        drag.track.style.scrollSnapType = 'none';
        drag.track.style.scrollBehavior = 'auto';
        if (drag.type === 'mouse') drag.track.style.cursor = 'grabbing';
      }
    }
    if (drag.axis !== 'x') return false;
    drag.track.scrollLeft = drag.startLeft - dx;
    return true;
  }
  function end() {
    if (!drag) return;
    var d = drag;
    drag = null;
    if (d.axis !== 'x') return;
    var w = d.track.clientWidth || 1;
    var dx = d.lastX - d.startX;
    var startIndex = Math.round(d.startLeft / w);
    var target = startIndex;
    if (dx <= -w * 0.12) target = startIndex + 1;
    else if (dx >= w * 0.12) target = startIndex - 1;
    var max = d.track.children.length - 1;
    target = Math.max(0, Math.min(max, target));
    d.track.style.cursor = '';
    d.track.scrollTo({ left: target * w, behavior: 'smooth' });
    setTimeout(function () { d.track.style.scrollSnapType = ''; d.track.style.scrollBehavior = ''; }, 450);
    var stop = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
    d.track.addEventListener('click', stop, { capture: true, once: true });
    setTimeout(function () { d.track.removeEventListener('click', stop, { capture: true }); }, 400);
  }
  function trackFrom(target) {
    if (!target || !target.closest) return null;
    if (target.closest('.zp-swipe__nav, .zp-swipe__dot, .zp-swipe__play, [data-zb-share], [data-zw-handle]')) return null;
    return target.closest('.zp-swipe__track');
  }

  document.addEventListener('touchstart', function (e) {
    if (e.touches.length !== 1) return;
    var track = trackFrom(e.target);
    if (!track) return;
    start(track, e.touches[0].clientX, e.touches[0].clientY, 'touch');
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (!drag || drag.type !== 'touch') return;
    if (move(e.touches[0].clientX, e.touches[0].clientY) && e.cancelable) e.preventDefault();
  }, { passive: false });
  document.addEventListener('touchend', function () { if (drag && drag.type === 'touch') end(); });
  document.addEventListener('touchcancel', function () { if (drag && drag.type === 'touch') end(); });

  document.addEventListener('mousedown', function (e) {
    if (e.button !== 0) return;
    var track = trackFrom(e.target);
    if (!track) return;
    start(track, e.clientX, e.clientY, 'mouse');
  });
  document.addEventListener('mousemove', function (e) {
    if (!drag || drag.type !== 'mouse') return;
    if (move(e.clientX, e.clientY)) e.preventDefault();
  });
  document.addEventListener('mouseup', function () { if (drag && drag.type === 'mouse') end(); });
  window.addEventListener('blur', function () { end(); });

  document.addEventListener('dragstart', function (e) {
    if (e.target.closest && e.target.closest('.zp-swipe__track')) e.preventDefault();
  });
})();
